import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellDisplayName, SortTableCellTextPill} from '../../../../../shared/models/sort-table/cell-classes';
import {BaseCellComponent} from '../_base-cell/base-cell.component';

/**
 * Produces a cell that has both a title and a subtitle. The subtitle
 * is enclosed in a pill.
 */
@Component({
    selector: 'motn-sort-display-name-cell',
    template: `
     {{cell.displayName}}
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sort-display-name-cell.component.scss'],
})
export class SortDisplayNameCellComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellDisplayName;


  constructor() {
    super();
  }


  protected onInit(): void {
  }


  onClick() {
    if (this.cell.clickCallback) {
      this.cell.clickCallback();
    }
  }
}
